import { theme } from 'antd'
import {
    TbFile,
    TbFileSpreadsheet,
    TbFileText,
    TbFileTypePdf,
    TbFileWord,
    TbFileZip,
    TbFolder,
    TbMovie,
    TbMusic,
    TbPhoto,
    TbPresentation,
} from 'react-icons/tb'

import { classNames } from '@/Ship/Helpers/classNames'

import { KIND_LABEL } from '../Helpers/diskFormat'

import type { DiskFileKind } from '../Contracts/DiskNode'
import type { GlobalToken } from 'antd'
import type { ReactNode } from 'react'

import styles from './Disk.module.css'

type Tone = 'warning' | 'error' | 'success' | 'info' | 'primary' | 'neutral'

const KIND_ICON: Record<DiskFileKind, { icon: ReactNode; tone: Tone }> = {
    folder: { icon: <TbFolder />, tone: 'warning' },
    pdf: { icon: <TbFileTypePdf />, tone: 'error' },
    spreadsheet: { icon: <TbFileSpreadsheet />, tone: 'success' },
    document: { icon: <TbFileWord />, tone: 'info' },
    presentation: { icon: <TbPresentation />, tone: 'warning' },
    image: { icon: <TbPhoto />, tone: 'info' },
    video: { icon: <TbMovie />, tone: 'primary' },
    audio: { icon: <TbMusic />, tone: 'primary' },
    text: { icon: <TbFileText />, tone: 'neutral' },
    archive: { icon: <TbFileZip />, tone: 'neutral' },
    other: { icon: <TbFile />, tone: 'neutral' },
}

/** Колір плашки — пара токенів antd, тож тема й бренд перемикають її самі. */
const toneColors = (token: GlobalToken, tone: Tone): { color: string; background: string } => {
    switch (tone) {
        case 'warning':
            return { color: token.colorWarning, background: token.colorWarningBg }
        case 'error':
            return { color: token.colorError, background: token.colorErrorBg }
        case 'success':
            return { color: token.colorSuccess, background: token.colorSuccessBg }
        case 'info':
            return { color: token.colorInfo, background: token.colorInfoBg }
        case 'primary':
            return { color: token.colorPrimary, background: token.colorPrimaryBg }
        default:
            return { color: token.colorTextSecondary, background: token.colorFillTertiary }
    }
}

export interface DiskNodeIconProps {
    kind: DiskFileKind
    size?: number
}

/** Іконка виду файлу або папки в кольоровій плашці. */
export const DiskNodeIcon = ({ kind, size = 32 }: DiskNodeIconProps) => {
    const { token } = theme.useToken()
    const meta = KIND_ICON[kind]
    const colors = toneColors(token, meta.tone)

    return (
        <span
            className={classNames(styles['tile'])}
            style={{ width: size, height: size, fontSize: Math.round(size * 0.56), ...colors }}
            title={KIND_LABEL[kind]}
            aria-hidden
        >
            {meta.icon}
        </span>
    )
}
